<div class="" *ngIf="bookings.length > 0">
    <div *ngFor="let booking of bookings">
        <div class="card bb-panel col-sm-12">
            <div class="row upcoming-booking">
                <div class="col-sm-8 row">
                    <div class="col-sm-12 row somePadding">
                        <span class="col-sm-12 col-md-6 item-label noPadding">{{'ACCOUNT.REF' | translate}}:</span>
                        <span class="col-sm-12 col-md-6 mb-1 noPadding">{{booking.id}}</span>
                    </div>
                    <div class="col-sm-12 row somePadding">
                        <span class="col-sm-12 col-md-6 item-label noPadding">{{'ACCOUNT.SERVICE' | translate}}:</span>
                        <span class="col-sm-12 col-md-6 mb-1 noPadding">{{booking.service_name}}</span>
                    </div>
                    <div class="col-sm-12 row somePadding">
                        <span class="col-sm-12 col-md-6 item-label noPadding">{{'ACCOUNT.LOCATION' | translate}}:</span>
                        <span class="col-sm-12 col-md-6 mb-1 noPadding">{{booking.full_describe.split('- ')[1].replace(booking.resource_name,"").replace(" at ","")}}</span>
                    </div>
                    <div class="col-sm-12 row somePadding">
                        <span class="col-sm-12 col-md-6 item-label noPadding">{{'ACCOUNT.DATE' | translate}}:</span>
                        <span class="col-sm-12 col-md-6 mb-1 noPadding">{{booking.datetime}}</span>
                    </div>
                    <div class="col-sm-12 row somePadding">
                        <span class="col-sm-12 col-md-6 item-label noPadding">{{'ACCOUNT.TIME' | translate}}:</span>
                        <span class="col-sm-12 col-md-6 mb-1 noPadding">{{booking.time}} - {{booking.endTime}}</span>
                    </div>
                </div>
                <div class="col-sm-4 text-right details-row vertical-center">
                    <button class="btn btn-primary govuk-button button-sizer col-sm-12 col-md-12 col-lg-9"
                        (click)="openModifyDialog(booking)">{{'ACCOUNT.AMEND' | translate}}</button>
                    <button class="btn btn-primary govuk-button button-sizer col-sm-12 col-md-12 col-lg-9"
                        (click)="openCancelDialog(booking)">{{'ACCOUNT.CANCEL' | translate}}</button>
                    <button class="btn btn-primary govuk-button button-sizer col-sm-12 col-md-12 col-lg-9"
                        (click)="openDetailsDialog(booking)">{{'ACCOUNT.DETAILS' | translate}}</button>
                </div>
            </div>
        </div>
        <br>
    </div>
</div>
<h2 class="no-bookings" *ngIf="bookings.length === 0">{{'ACCOUNT.NO_UPCOMING_BOOKINGS' | translate}}</h2>